import { createSlice } from '@reduxjs/toolkit';
import { IWorkspace } from '../../types/Workspace';
import { setCurrentLocalStorageWorkspace } from '../../utils/localstorage';

interface IWorkspaceStore {
  currentWorkspace: IWorkspace | null;
}

const initialState: IWorkspaceStore = {
  currentWorkspace: null,
};

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setCurrentWorkspace(state, { payload }) {
      state.currentWorkspace = payload;
      setCurrentLocalStorageWorkspace(payload?.id);
    },
  },
});

export const { setCurrentWorkspace } = workspaceSlice.actions;
export default workspaceSlice.reducer;
